/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const CustomerJourneyQuestion = {
	DoesTheVehicleHaveCNG: 'DoesTheVehicleHaveCNG',
	ArmoredVehicle: 'ArmoredVehicle',
	DoesTheVehicleHaveModifiedSuspension: 'DoesTheVehicleHaveModifiedSuspension',
	WasTheChassisNumberRemarked: 'WasTheChassisNumberRemarked',
} as const;
export type CustomerJourneyQuestion =
	(typeof CustomerJourneyQuestion)[keyof typeof CustomerJourneyQuestion];

export function instanceOfCustomerJourneyQuestion(value: any): boolean {
	for (const key in CustomerJourneyQuestion) {
		if (Object.prototype.hasOwnProperty.call(CustomerJourneyQuestion, key)) {
			if (CustomerJourneyQuestion[key as keyof typeof CustomerJourneyQuestion] === value) {
				return true;
			}
		}
	}
	return false;
}

export function CustomerJourneyQuestionFromJSON(json: any): CustomerJourneyQuestion {
	return CustomerJourneyQuestionFromJSONTyped(json, false);
}

export function CustomerJourneyQuestionFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CustomerJourneyQuestion {
	return json as CustomerJourneyQuestion;
}

export function CustomerJourneyQuestionToJSON(value?: CustomerJourneyQuestion | null): any {
	return value as any;
}

export function CustomerJourneyQuestionToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): CustomerJourneyQuestion {
	return value as CustomerJourneyQuestion;
}
